import Mutations from '../../odata/mutations';

export default { ...new Mutations('packingListItem'), ...new Mutations('packingListItems') };
